import { TextKey } from '@mews-commander/enums';
import { AdditionalSearchType, SearchSubSection, SearchType } from './assistantSearchTypes';
import {
    BillFilter,
    CompanyFilter,
    CustomerFilter,
    ReservationFilter,
    SpaceFilter,
} from './assistantSearchTypeFilters';

export const EntityKeys = {
    [AdditionalSearchType.All]: TextKey.All,
    [SearchSubSection.Command]: TextKey.AssistantResultSectionCommand,
    [SearchType.AvailabilityBlock]: TextKey.AvailabilityBlock,
    [SearchType.Bill]: TextKey.Bill,
    [SearchType.Customer]: TextKey.Customer,
    [SearchType.Company]: TextKey.Company,
    [SearchType.City]: TextKey.City,
    [SearchType.Reservation]: TextKey.Reservation,
    [SearchType.ReservationGroup]: TextKey.Group,
    [SearchType.Resource]: TextKey.Space,
    [SearchType.TravelAgency]: TextKey.TravelAgencyContract,
    [SearchType.ResourceBlock]: TextKey.SpaceBlock,
    [SearchType.Locations]: TextKey.Location,
    [SearchType.Navigation]: TextKey.Navigation,
    [SearchType.EnterpriseProfile]: TextKey.Employee,
    [SearchType.ProductServiceOrder]: TextKey.ProductOrder,
    [SearchType.RoutingRule]: TextKey.BillingAutomation,
};
export const FilterKeys = {
    [ReservationFilter.Canceled]: TextKey.ServiceOrderStateCanceled,
    [ReservationFilter.CheckedIn]: TextKey.CheckedIn,
    [ReservationFilter.CheckOut]: TextKey.CheckOut,
    [ReservationFilter.CheckOutOnLine]: TextKey.CheckOutOnline,
    [ReservationFilter.Confirmed]: TextKey.ServiceOrderStateConfirmed,
    [ReservationFilter.Inquired]: TextKey.ServiceOrderStateInquired,
    [ReservationFilter.Optional]: TextKey.ServiceOrderStateOptional,
    [ReservationFilter.Past]: TextKey.Past,
    [ReservationFilter.CheckOutMissed]: TextKey.ReservationTimeStateCheckOutMissed,
    [ReservationFilter.CheckInMissed]: TextKey.ReservationTimeStateCheckInMissed,
    [ReservationFilter.ToBeCheckedIn]: TextKey.ReservationTimeStateToBeCheckedIn,
    [ReservationFilter.ToBeCheckedOut]: TextKey.ReservationTimeStateToBeCheckedOut,
    [ReservationFilter.Future]: TextKey.Future,
    [ReservationFilter.CheckInOnLine]: TextKey.CheckInOnline,
    [SpaceFilter.Clean]: TextKey.Clean,
    [SpaceFilter.Dirty]: TextKey.Dirty,
    [SpaceFilter.Inspected]: TextKey.Inspected,
    [SpaceFilter.OutOfOrder]: TextKey.OutOfOrder,
    [SpaceFilter.OutOfService]: TextKey.OutOfService,
    [SpaceFilter.Unassigned]: TextKey.Unassigned,
    [CustomerFilter.isVip]: TextKey.VIP,
    [CustomerFilter.isInHouse]: TextKey.InHouse,
    [CustomerFilter.isPaymaster]: TextKey.Paymaster,
    [BillFilter.Open]: TextKey.Open,
    [BillFilter.Closed]: TextKey.Closed,
    [BillFilter.Receipt]: TextKey.Receipt,
    [BillFilter.Invoice]: TextKey.Invoice,
    [BillFilter.Overdue]: TextKey.Overdue,
    [CompanyFilter.Inactive]: TextKey.Inactive,
    [CompanyFilter.Internal]: TextKey.Internal,
    [CompanyFilter.Marketing]: TextKey.Marketing,
    [CompanyFilter.isTravelAgency]: TextKey.TravelAgency,
};

export const AssistantFilterChipsKeys = { ...FilterKeys, ...EntityKeys };
